const PropTypes = require("prop-types");
const SuffixedInput = require("components/forms/SuffixedInput");
const PriceAbstract = require("components/abstract/Price");
const assign = require("object-assign");

class Price extends PriceAbstract {

	static get propTypes() {
		return assign(super.propTypes, {
			renderHiddenFields: PropTypes.bool
		});
	}

	static get defaultProps() {
		return assign(super.defaultProps, {
			renderHiddenFields: true
		});
	}

	render() {
		return (
			<SuffixedInput className={this.className} inputRef={this._setInputRef} defaultValue={this.state.value}
										 data-name={this.props.name}
										 onInput={this._onInput} suffix={this.props.currency} {...this.inputProps}>
				{this.renderHiddenFields()}
				{this.props.children}
			</SuffixedInput>
		);
	}

	renderHiddenFields() {
		if (this.props.renderHiddenFields) {
			return (<input type="hidden" name={this.props.name} value={this.state.value}/>);
		}
	}

}

module.exports = Price;



// WEBPACK FOOTER //
// ./resources/js/components/forms/Price.js